import React, { useState, useEffect, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { referenceDataService, authenticationService, EvaluationCategoryData, cmsDataservice, userService, jwplayerService,messageCenterService, contactus, ClinicEventCategoryData, eventCalendarService, permissionService, CurriculumMasterData, tagAssignmentService } from "../services";
import { ContactUsFeedbackService } from '../services/contactus.service';
import Helper from './Helper';
import { CMSRouteSlug } from './RouteConstants';
import * as signalR from '@microsoft/signalr';
import moment from "moment";
import { AbilityContext } from '../common/Can';
import { defineRulesfor } from "./Permission";
import AppConstants from "./AppConstants";

export const AppDataContext = React.createContext();
export const AppDataProvider = (props) => {
  const ability = useContext(AbilityContext)


  const [user, setUser] = useState(null);

  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [gameTypeList, setGameTypeList] = useState([]);
  const [schoolLevelList, setSchoolLevelList] = useState([]);
  const [experienceTypeList, setExperienceTypeList] = useState([]);
  const [gameCountList, setGameCountList] = useState([]);
  const [experienceSubTypeList, setExperienceSubTypeList] = useState([]);
  const [experienceSubType2List, setExperienceSubType2List] = useState([]);
  const [socialMediaList, setSocialMediaList] = useState([]);
  const [messageCenterCategoryList, setMessageCenterCategoryList] = useState([]);
  const [affiliationNetworkList, setAffiliationNetworkList] = useState([]);
  const [partnerOrganizationList, setPartnerOrganizationList] = useState([]);
  const [experienceLevelList, setExperienceLevelList] = useState([]);
  const [userList, setUserList] = useState([]);
  // const [allUsersList, setAllUsersList] = useState([]);
  const [eventTypeList, setEventTypeList] = useState([]);
  const [eventSubType1List, setEventSubType1List] = useState([]);
  const [eventSubType2List, setEventSubType2List] = useState([]);
  //  const [adminDataList, setAdminData] = useState([]);
  const [adminScoutDataList, setAdminScoutData] = useState([]);
  const [poolDataList, setPoolDataList] = useState([]);
  const [stateWiseProfiles, setStateWiseProfiles] = useState([]);
  const [experienceLevels, setExperienceLevels] = useState([]);
  const [scoutObservations, setScoutObservations] = useState({});
  const [userActivities, setUserActivities] = useState({});
  const [hireActivities, setHireActivites] = useState([]);
  const [isLoadingDashboardData, setIsLoadingDashboardData] = useState(false);
  const [totalHireInfo, setTotalHireInfo] = useState([]);
  const [rpsmCount, setRpsmCount] = useState(0);
  const [nbaCandidateCampsList, setNBACandidateCampsList] = useState([]);
  const [primaryScoutList, setPrimaryScoutList] = useState([]);
  const [initiativeList, setInitiativeList] = useState([]);
  const [aboutSourceList, setAboutSourceList] = useState([]);
  const [mostActiveProspectCount, setMostActiveProspectCount] = useState([]);
  const [leastActiveProspectCount, setLeaseActiveProspectCount] = useState([]);
  const [scoutEventCount, setScoutEventCount] = useState([]);
  const [eventCount, setEventCount] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setsubCategory] = useState([])
  const [evaluationEvents, setevaluationEvents] = useState([]);
  const [competency, setCompitancy] = useState([])
  const [refereeList, setRefereeList] = useState([])
  const [snackMessages, setSnackMessages] = useState([])
  const [navigationMenu, setNavigationMenu] = useState([]);
  const [jwtTokenDetails, setJwtTokenDetails] = useState(null);

  const [seasonDates, setSeasonDates] = useState(null);
  const [savedFromDate, setSavedFromDate] = useState(null);
  const [savedToDate, setSavedToDate] = useState(null);
  const [savedSeasonYear, setSavedSeasonYear] = useState('');

  const [savedEventFromDate, setSavedEventFromDate] = useState(null);
  const [savedEventToDate, setSavedEventToDate] = useState(null);
  const [savedEventSeasonYear, setSavedEventSeasonYear] = useState('');


  const [promptData, setPromptData] = useState({
    isRouteBlocked: false,
    message: ""
  });
  const location = useLocation();
  const [roles, setRoles] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([])
  const [availableRoleData, setAvailableRoleData] = useState([])
  const [notificationCountChanged, setNotificationCountChanged] = useState(true);
  //const [hubConnection, setHubConnection] = useState(new signalR.HubConnectionBuilder().withUrl(referenceDataService.getSignalRUrl()).withAutomaticReconnect().configureLogging(signalR.LogLevel.Information).build());
  //const [hubConnected, setHubConnected] = useState(false);
  const [prospectDetails, setProspectDetails] = useState(null);
  const [poolProspect, setPoolProspect] = useState([]);
  const [seasonTypeList, setSeasonTypeList] = useState([]);
  const [isLoadingEvents, setIsLoadingEvents] = useState(false);
  const [sitekey, setSitekey] = useState("");
  const [faqs, setFaqs] = useState();
  const [tangibles, setTangibles] = useState([]);
  const [eventCategoryList, setEventCategoryList] = useState([])
  const [eventSubCategoryList, setEventSubCategoryList] = useState([])
  const [clinicEvents, setClinicEvents] = useState([])
  const [allPermissions, setAllPermissions] = useState([])
  const [permissionVerbList, setPermissionVerbList] = useState([])
  const [leagues, setLeagues] = useState([{ id: '00', displayName: 'NBA' }, { id: '10', displayName: 'WNBA' }, { id: '20', displayName: 'G-League' }])

  //

  const [curriculumResourceTypes, setCurriculumResourceTypes] = useState([])
  const [curriculumBadges, setCurriculumBadges] = useState([])
  const [curriculumLevels, setCurriculumLevels] = useState([])
  const [curriculums, setCurriculums] = useState([])
  const [curriculumQuestionTypes, setCurriculumQuestionTypes] = useState([])
  const [curriculumMediaTypes, setCurriculumMediaTypes] = useState([])
  const [curriculumQuestionLevels, setCurriculumQuestionLevels] = useState([])
  const [sectionTypes, setSectionTypes] = useState([])
  //const [auditTypes, setAuditTypes] = useState([])
  const [quizTypes, setQuizTypes] = useState([])
  let [fetchingData, setFetchingData] = useState(false)
  const [allTags, setAllTags]=useState([])

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (!navigationMenu.length) {
  //       getNavigationMenu();
  //     }
  //     if (!jwtTokenDetails) {
  //       getJWToken();
  //     }
  //     let currentUser = authenticationService.getUser();
  //     // if (!currentUser) {
  //     //   currentUser = await authenticationService.getUserDetails();
  //     //   if (currentUser.isAuthenticated) {
  //     //     authenticationService.setCurrentUser(currentUser);
  //     //     setUser(currentUser);
  //     //   }
  //     // }
  //     //authenticationService.currentUser.subscribe(async currentUser => {

  //     if (currentUser && currentUser.lastLoginDate !== null) {
  //       setUser(currentUser);
  //       let roleId = currentUser.roleId//Helper.getUserRoleId();
  //       //if (roleId && roleId !== '') {
  //       //let permissions = await authenticationService.getPermissionByRole()
  //       //let rules = defineRulesfor(permissions)
  //       //ability.update(rules)
  //       //}
  //       if (checkRole('Admin', currentUser) || checkRole('Scout', currentUser) || checkRole('AdminScout', currentUser) || checkRole('EventAdmin', currentUser) || checkRole('CurriculumAdmin', currentUser)) {
  //         getMasterDataForAdminRole();
  //         //getCategoryData();
  //         //getCompetencyData();
  //         getSeasonData();
  //         //getTangibleData();
  //         //getPermissions();
  //         //getVerbsList();
  //         //getCategoryList()
  //         getRoles()
  //         //fetchAllCurriculumMasterData()
  //         //getEvents();
  //         //getAuditTypes();
  //       }
  //       if (checkRole('CurriculumAdmin', currentUser)) {
  //         //getPermissions();
  //         //fetchAllCurriculumMasterData()
  //       }
  //       if (checkRole('Partner', currentUser)) {
  //         getMasterDataForUserRole();
  //       }
  //       if (checkRole('User', currentUser)) {
  //         getMasterDataForUserRole();
  //         //getEvents();
  //         //getCategoryList()
  //         getRoles()
  //       }
  //     }
  //     else {
  //       getMasterDataForGuestRole();
  //     }
  //     //getFaqsData();
  //   }
  //   if (props.user && !fetchingData) {
  //     setFetchingData(true)
  //     fetchData()
  //   }
  //   return () => {
  //     setFetchingData(false)
  //   }
  //   //});
  // }, [props.user]);

  useEffect(() => {
    if (props.user) {
      //setFetchingData(true)
      //fetchDefaultData(props.user)
      setUser(props.user)
    }
    if (roles.length === 0) {
      setRoles(AppConstants.ROLES);
    }
  }, [props.user]);

  useEffect(() => {
    if (user && !fetchingData) {
      setFetchingData(true)
      fetchDefaultData(user)
    } else {
      if (!jwtTokenDetails) {
        getJWToken();
      }
      //getMasterDataForGuestRole();
    }
    return () => {
      setFetchingData(false)
    }
  }, [user]);

  const fetchDefaultData = async (user) => {
    // if (!navigationMenu.length) {
    //   getNavigationMenu();
    // }
    if (!jwtTokenDetails) {
      getJWToken();
    }


    //setUser(user);
    if (user && user.lastLoginDate !== null) {
      let roleId = user.roleId//Helper.getUserRoleId();
      // if (roleId && roleId !== '') {
      //   let permissions = await authenticationService.getPermissionByRole(roleId)
      //   let rules = defineRulesfor(permissions)
      //   ability.update(rules)
      // }
      if (checkRole('Admin', user) || checkRole('Scout', user) || checkRole('AdminScout', user) || checkRole('EventAdmin', user) || checkRole('CurriculumAdmin', user)) {
        getMasterDataForAdminRole();

        //getCategoryData();
        //getCompetencyData();
        getSeasonData();
        //getTangibleData();
        //getCategoryList()
        //getRoles()
        //getPermissions()
        //getVerbsList()

      }
      if (checkRole('CurriculumAdmin', user)) {
        //getPermissions();
        // fetchAllCurriculumMasterData()
      }
      if (checkRole('Partner', user)) {
        //getMasterDataForUserRole();
      }
      if (checkRole('User', user)) {
        //getMasterDataForUserRole();
        //getEvents();
        //getCategoryList()
        //getRoles()
      }
    }
    else {
      //getMasterDataForGuestRole();
    }

  }

  useEffect(() => {
    // runs on location, i.e. route, change
    setPromptData({
      isRouteBlocked: false
    });
    // console.log('handle route change here', location)
  }, [location]);

  const getJWToken = () => {
    jwplayerService.getToken()
      .then(token => {
        setJwtTokenDetails(token.data);
        //updatejwTokenDetails(token);
      })
  }

  const getMessageCenterCategoryList = () => {
    referenceDataService.getCommunicationCategoryList()
      .then(res => {
        if (res) {
          setMessageCenterCategoryList(res);
        }
      })
  }

  const updateNotificationCount = (notificationFlag) => {
    setNotificationCountChanged(notificationFlag);
  }

  const updateMessageCategoryList = (categoryList) => {
    setMessageCenterCategoryList(categoryList);
  }

  // const updateAllUsersList = (data) => {
  //   setAllUsersList(data);
  // }

  const updateDashboardStateList = (stateList) => {
    setStateWiseProfiles(stateList)
  }

  const updateDashboardExperienceList = (experienceList) => {
    setExperienceLevels(experienceList)
  }

  const getUpdatedEvaluationEvents = (postData) => {
    if (postData === undefined || postData === null) {
      postData = {
        eventName: '',
        gameType: 0,
        eventFrom: null,
        eventTo: null,

      }
    }

    setIsLoadingEvents(true)
    EvaluationCategoryData.getEvaluationEvents(postData)
      .then(result => {
        let dataEvents = result.map((item) => {


          return {
            ...item,
            eventFrom: Helper.FormatDate(item.eventFrom),
            eventTo: Helper.FormatDate(item.eventTo),

          }
        });
        setevaluationEvents(dataEvents)
        setIsLoadingEvents(false)
      })

  }

  const getCategoryData = () => {

    EvaluationCategoryData.getAllEvaluationCategoryList()
      .then(result => {
        let categories = result.map(category => { return { id: category.id, categoryName: category.categoryName, categoryActive: category.categoryActive } })
        let subcategories = [];
        result.forEach(category => {
          let subdata = category.subCategories
          subdata && subdata.length > 0 && subdata.forEach(sub => {
            sub['categoryName'] = category.categoryName;
            subcategories.push(sub);
          })
          setCategory(categories);
          setsubCategory(subcategories);
        });

      })

  }

  //need to uncomment the call
  const fetchAllCurriculumMasterData = () => {
    //getAllResourceTypes()
    //getAllBadges()
    //getAllCurriculumLevels()
    // getAllMasterCurriculums()
    // getAllQuestionTypes()
    // getAllMediaTypes()
    //getAllCurriculumQuestionLevels()
    //getAllSectionTypes()
    getAllQuizTypes()
  }

  const getCompetencyData = () => {

    EvaluationCategoryData.getCompetenciesList()
      .then(result => {
        setCompitancy(result);
      })

  }

  const getTangibleData = () => {

    EvaluationCategoryData.getTangibleList()
      .then(result => {
        setTangibles(result);
      })

  }

  const getSeasonData = () => {

    EvaluationCategoryData.getSeasonType('Season')
      .then(result => {
        setSeasonTypeList(result)
      })
  }

  const getDashBoardData = () => {

    setIsLoadingDashboardData(true)
    referenceDataService.getDashboardData().then(response => {
      if (response.data) {
        // if (response.data.stateWiseProfiles) {
        //   setStateWiseProfiles(response.data.stateWiseProfiles)
        // }
        // if (response.data.experienceLevels) {
        //   setExperienceLevels(response.data.experienceLevels)
        // }
        // if (response.data.scoutObservations) {
        //   setScoutObservations(response.data.scoutObservations)
        // }
        // if (response.data.userActivities) {
        //   setUserActivities(response.data.userActivities)
        // }
        if (response.data.hireActivities) {
          setHireActivites(response.data.hireActivities)
        }
        if (response.data.totalHiredInfo) {
          setTotalHireInfo(response.data.totalHiredInfo);
        }
        if (response.data.rpsmCount) {
          setRpsmCount(response.data.rpsmCount);
        }
        if (response.data.mostActiveProspectCounts) {
          setMostActiveProspectCount(response.data.mostActiveProspectCounts)
        }
        if (response.data.leastActiveProspectCounts) {
          setLeaseActiveProspectCount(response.data.leastActiveProspectCounts);
        }
        if (response.data.scoutEventCounts) {
          setScoutEventCount(response.data.scoutEventCounts)
        }
        if (response.data.eventCounts) {
          setEventCount(response.data.eventCounts);
        }
        // if (response.data.prospectDetails) {
        //   setProspectDetails(response.data.prospectDetails);
        // }
        if (response.data.poolProspect) {
          setPoolProspect(response.data.poolProspect);
        }
      }
      setIsLoadingDashboardData(false)
    })

  }

  const checkRole = (role, userData) => {
    let userRole = userService.getUserRole();
    if (!role) return false;
    if (role === '*') return true;

    if (role) {
      if (Array.isArray(role)) {
        return role.find(r => r && r.toLowerCase() === userRole.toLowerCase());
      }

      return role.toLowerCase() === userRole.toLowerCase();
    }

    return false;
  }

  const getMasterDataForGuestRole = () => {
    // To Do... add api to get location, experience level data 
    referenceDataService.getGuestMasterdata().then(res => {
      if (res.data) {
        if (res.data.state) {
          setStateList(res.data.state)
        }
        if (res.data.country) {
          setCountryList(res.data.country)
        }
        // if (res.data.experienceLevel) {
        //   setExperienceLevelList(res.data.experienceLevel)
        // }
        // if (res.data.messageCenterCategory) {
        //   // console.log(res.data.messageCenterCategory)
        //   setMessageCenterCategoryList(res.data.messageCenterCategory)
        // }
        // if (res.data.aboutUsSource) {
        //   // console.log(res.data.messageCenterCategory)
        //   setAboutSourceList(res.data.aboutUsSource)
        // }





      }
    })

    //getSiteKey();
  }

  const getSiteKey = () => {
    userService.getSitekeyForRecaptcha()
      .then(data => {
        setSitekey(data.data);
      })
  }
  const getCategoryList = () => {
    var data = { "EventType": '', "ParentId": -1 };
    ClinicEventCategoryData.getAllEventCategoryList(data).then(res => {
      setEventCategoryList(res && res?.length > 0 ? res.filter(x => x.parentID == 0) : []);
      setEventSubCategoryList(res && res?.length > 0 ? res.filter(x => x.parentID != 0) : [])
    });
  }
  const getFaqsData = () => {
    ContactUsFeedbackService.getFaqs()
      .then(data => {
        setFaqs(data.data)
      })
  }

  const getMasterDataForUserRole = () => {
    userService.getProfileMasterData().then(data => {
      // if (data.state) {
      //   setStateList(data.state)
      // }
      // if (data.country) {
      //   setCountryList(data.country)
      // }
      // if (data.timeZone) {
      //   setTimeZoneList(data.timeZone)
      // }
      // if (data.gameType) {
      //   setGameTypeList(data.gameType)
      // }
      // if (data.schoolLevel) {
      //   setSchoolLevelList(data.schoolLevel)
      // }
      // if (data.experienceType) {
      //   setExperienceTypeList(data.experienceType)
      // }
      // if (data.gameCount) {
      //   setGameCountList(data.gameCount)
      // }
      // if (data.experienceSubType) {
      //   setExperienceSubTypeList(data.experienceSubType)
      // }
      // if (data.experienceSubType2) {
      //   setExperienceSubType2List(data.experienceSubType2);
      // }
      // if (data.socialMedia) {
      //   setSocialMediaList(data.socialMedia);
      // }
      // if (data.affiliationNetwork) {
      //   setAffiliationNetworkList(data.affiliationNetwork);
      // }
      // if (data.partnerOrganization) {
      //   setPartnerOrganizationList(data.partnerOrganization);
      // }
      // if (data.experienceLevel) {
      //   setExperienceLevelList(data.experienceLevel);
      // }
      // if (data.officiatingEventsType) {
      //   setEventTypeList(data.officiatingEventsType);
      // }
      // if (data.officiatingEventsSubType1) {
      //   setEventSubType1List(data.officiatingEventsSubType1);
      // }
      // if (data.officiatingEventsSubType2) {
      //   setEventSubType2List(data.officiatingEventsSubType2);
      // }
      // if (data.aboutUsSource) {
      //   setAboutSourceList(data.aboutUsSource)
      // }
      // if (data.messageCenterCategory) {
      //   setMessageCenterCategoryList(data.messageCenterCategory)
      // }
    }).catch((e) => {
      //Helper.Logout();

    });
  }

  const getExperienceTypeMaster = () => {
    referenceDataService.getExperienceTypeMaster()
      .then(res => {
        if (res) {
          setExperienceTypeList(res.experienceType)
          setExperienceSubTypeList(res.experienceSubType)
          setExperienceSubType2List(res.experienceSubType2)
        }
      }).catch((e) => {
        //Helper.Logout();
        console.log(e)
      });
  }

  const getExperienceLevelMaster = () => {
    referenceDataService.getExperienceLevelMaster()
      .then(res => {
        if (res) {
          setExperienceLevelList(res);
        }
      }).catch((e) => {
        //Helper.Logout();
        console.log(e)
      });
  }

  const setMasterRoles = (roles) => {
    //setAvailableRoleData(roles)
    if (roles && roles?.length > 0) {
      let roleList = roles && roles?.length > 0 ? roles?.map(item => item.roleCode) : [];
      let roleArr = {};
      roleList.forEach(role => {
        roleArr = { ...roleArr, [role.toLowerCase()]: role }
      })

      //setAvailableRoles(roleList);
      setRoles(roleArr);
    }
  }
  const getRoles = () => {
    referenceDataService.getRoles()
      .then(result => {
        //setMasterRoles(result)
        setAvailableRoleData(result)
      })
  }

  const getPermissions = () => {
    permissionService.getAllPermissions()
      .then(result => {
        setAllPermissions(result.data)
      })
  }

  const getVerbsList = () => {
    referenceDataService.getMasterDataByName('PermissionVerb').then(res => {
      setPermissionVerbList(res.data);
    });
  }


  // const getAuditTypes = () => {
  //   referenceDataService.getAuditTypes()
  //     .then(result => {
  //       setAuditTypes(result)
  //     })
  // }

  const getTimeZoneMaster = () => {
    referenceDataService.getTimezoneMaster()
      .then(result => {
        setTimeZoneList(result);
      })
      .catch((e) => {
        console.log(e)
      });
  }

  const getSchoolLevelMaster = () => {
    referenceDataService.getSchoolLevelMaster()
      .then(result => {
        setSchoolLevelList(result);
      })
      .catch((e) => {
        console.log(e)
      });
  }

  const getMasterDataForAdminRole = () => {

    referenceDataService.getMasterData()
      .then(data => {
        if (data) {
          // if (data.state) {
          //   setStateList(data.state)
          // }
          // if (data.country) {
          //   setCountryList(data.country)
          // }
          // if (data.timeZone) {
          //   setTimeZoneList(data.timeZone)
          // }
          if (data.gameType) {
            setGameTypeList(data.gameType)
          }
          // if (data.schoolLevel) {
          //   setSchoolLevelList(data.schoolLevel)
          // }
          // if (data.experienceType) {
          //   setExperienceTypeList(data.experienceType)
          // }
          // if (data.gameCount) {
          //   setGameCountList(data.gameCount)
          // }
          // if (data.experienceSubType) {
          //   setExperienceSubTypeList(data.experienceSubType)
          // }
          // if (data.experienceSubType2) {
          //   setExperienceSubType2List(data.experienceSubType2);
          // }
          // if (data.socialMedia) {
          //   setSocialMediaList(data.socialMedia);
          // }
          // if (data.messageCenterCategory) {
          //   setMessageCenterCategoryList(data.messageCenterCategory);
          // }
          // if (data.affiliationNetwork) {
          //   setAffiliationNetworkList(data.affiliationNetwork);
          // }
          // if (data.partnerOrganization) {
          //   setPartnerOrganizationList(data.partnerOrganization);
          // }
          // if (data.experienceLevel) {
          //   setExperienceLevelList(data.experienceLevel);
          // }
          // if (data.userData) {
          //   setUserList(data.userData);
          // }
          // if (data.allUsersData) {
          //   setAllUsersList(data.allUsersData)
          // }
          // if (data.officiatingEventsType) {
          //   setEventTypeList(data.officiatingEventsType);
          // }
          // if (data.officiatingEventsSubType1) {
          //   setEventSubType1List(data.officiatingEventsSubType1);
          // }
          // if (data.officiatingEventsSubType2) {
          //   setEventSubType2List(data.officiatingEventsSubType2);
          // }
          // if (data.candidateCamps) {
          //   setNBACandidateCampsList(data.candidateCamps);
          // }
          // if (data.poolData) {
          //   setPoolDataList(data.poolData)
          // }
          if (data.primaryScouts) {
            let x = data.primaryScouts;
            x.push({ primaryScoutID: "none", primaryScoutName: "None" })
            setPrimaryScoutList(x);
          }
          // if (data.initiatives) {
          //   setInitiativeList(data.initiatives);
          // }
          // if (data.aboutUsSource) {
          //   setAboutSourceList(data.aboutUsSource);
          // }
        }
      }).catch((e) => {
        Helper.Logout();
      });

    referenceDataService.getSeasonDates().then(response => {
      if (response.data) {
        setSeasonDates(response.data);

      }
    })




    // referenceDataService.getState().then(response => {
    //   if (response.data) {
    //     setStateList(response.data)
    //   }
    // })


    // referenceDataService.getPoolList().then(response => {
    //   if (response) {
    //     setPoolDataList(response.data)
    //   }
    // })


    // referenceDataService.getAdminData().then(data => {
    //   if (data) {
    //     if (data) {
    //       setAdminData(data)
    //     }
    //   }
    // })

    // referenceDataService.getAdminScoutData().then(data => {
    //   if (data) {
    //     setAdminScoutData(data)
    //   }
    // })

    // getDashBoardData();

    // getCategoryData();

    // getCompetencyData();

    // referenceDataService.getRefStatRefereeList()
    //   .then(result => {
    //     setRefereeList(result);
    //   })


  }

  const getGameCountMaster = () => {
    referenceDataService.getGameCountMaster()
      .then(result => {
        setGameCountList(result);
      })
      .catch((e) => {
        console.log(e)
      });
  }
  const getRefereeList = () => {
    referenceDataService.getRefStatRefereeList()
      .then(result => {
        setRefereeList(result);
      })
  }

  const getAdminScoutsList = () => {
    referenceDataService.getAdminScoutData().then(data => {
      if (data) {
        setAdminScoutData(data)
      }
    })
  }

  const getCountryList = () => {
    referenceDataService.getCountryList().then(response => {
      if (response) {
        setCountryList(response)
      }
    })
  }

  const getStateList = () => {
    referenceDataService.getState().then(response => {
      if (response.data) {
        setStateList(response.data)
      }
    })
  }

  const getUsersList = () => {
    referenceDataService.getUsersList().then(data => {
      if (data) {
        setUserList(data)
      }
    })
  }

  const getNavigationMenu = () => {
    cmsDataservice.getCMSContentBySlug(CMSRouteSlug.MENU).then(res => {
      setNavigationMenu(res);
    });
  }

  const getPoolList = () => {
    referenceDataService.getPoolList().then(response => {
      if (response) {
        setPoolDataList(response.data)
      }
    })
  }

  // const refreshPoolData = () => {
  //   referenceDataService.getPoolList().then(response => {
  //     if (response) {
  //       setPoolDataList(response.data)
  //     }
  //   })
  // }

  const updateEvaluationCateAndSubCate = (list) => {
    setCategory(list.categoryList)
    setsubCategory(list.subCategoryList)
  }
  const updateEvalCompitancy = (compitancyList) => {
    setCompitancy(compitancyList)
  }
  // const updateHubConnectedStatus = (status) => {
  //   setHubConnected(status);
  // }

  const updatedDashboardFromDateState = (fromDate) => {
    setSavedFromDate(fromDate)
  }

  const updatedDashboardToDateState = (toDate) => {
    setSavedToDate(toDate)
  }

  const updatedDashboardSeasonYearState = (seasonYear) => {
    setSavedSeasonYear(seasonYear)
  }

  const refreshDashboardDatesState = () => {
    setSavedFromDate(null)
    setSavedToDate(null)
    setSavedSeasonYear('')
  }

  const updateDashboardDatesState = (fromDate, toDate, seasonYear) => {
    setSavedFromDate(fromDate)
    setSavedToDate(toDate)
    setSavedSeasonYear(seasonYear)
  }
  //
  const updatedEventDashboardFromDateState = (fromDate) => {
    setSavedEventFromDate(fromDate)
  }

  const updatedEventDashboardToDateState = (toDate) => {
    setSavedEventToDate(toDate)
  }

  const updatedEventDashboardSeasonYearState = (seasonYear) => {
    setSavedEventSeasonYear(seasonYear)
  }

  const refreshEventDashboardDatesState = () => {
    setSavedEventFromDate(null)
    setSavedEventToDate(null)
    setSavedEventSeasonYear('')
  }

  const updateEventDashboardDatesState = (fromDate, toDate, seasonYear) => {
    setSavedEventFromDate(fromDate)
    setSavedEventToDate(toDate)
    setSavedEventSeasonYear(seasonYear)
  }
  //

  //get past 3month and upcoming 1 months events
  const getEvents = () => {
    let endDate = Helper.FormatDateToLocalTimeZone(moment().add(1, 'months'));
    let startDate = Helper.FormatDateToLocalTimeZone(moment().subtract(3, 'months'));
    let type = 'past'
    // setIsLoadingEvents(true);
    eventCalendarService.getYAOPublicEvents(1, 999, startDate, endDate, type).then((result) => {
      setClinicEvents(result.data.eventCalendarList);
      // setIsLoadingEvents(false);
    }).catch((e) => console.error(e));

  }



  //curriculum masters
  const getAllResourceTypes = () => {

    CurriculumMasterData.getResourceTypes()
      .then(result => {
        setCurriculumResourceTypes(result);
      })

  }

  const getAllBadges = () => {

    CurriculumMasterData.getBadges()
      .then(result => {
        setCurriculumBadges(result);
      })

  }

  const getAllTags = () => {
    tagAssignmentService.getAllTags()
      .then(result => {
        setAllTags(result);
      })
    }

  const updateAllTags=(tags)=>{
    setAllTags(tags);
  }

  const getAllCurriculumLevels = () => {

    CurriculumMasterData.getLevels()
      .then(result => {
        setCurriculumLevels(result);
      })

  }

  const getAllMasterCurriculums = () => {
    //  setIsLoading(true)
    CurriculumMasterData.getCurriculums()
      .then(result => {
        setCurriculums(result);
        // setIsLoading(false)
      }).catch(err => {
        // console.log(err);
        // addSnackMessages([{
        //     open: true,
        //     severity: 'error',
        //     message: "some error occured, try again later."
        // }]);
        // setIsLoading(false)
      })
  }

  const getAllQuestionTypes = () => {
    CurriculumMasterData.getQuestionTypes()
      .then(result => {
        setCurriculumQuestionTypes(result);
      })

  }

  const getAllMediaTypes = () => {
    CurriculumMasterData.getMediaTypes()
      .then(result => {
        setCurriculumMediaTypes(result);
      })

  }

  const getAllCurriculumQuestionLevels = () => {
    CurriculumMasterData.getQuestionLevels()
      .then(result => {
        setCurriculumQuestionLevels(result);
      })

  }

  const getAllSectionTypes = () => {
    CurriculumMasterData.getSectionType()
      .then(result => {
        setSectionTypes(result);
      })
  }

  const getAllQuizTypes = () => {
    CurriculumMasterData.getAllQuizType()
      .then(result => {
        setQuizTypes(result);
      })
  }

  const updateCurriculumBadge = (badges) => {
    setCurriculumBadges(badges);
  }

  const resetAppContext = () => {
    setUser(null);
    setStateList([]);
    setCountryList([]);
    setGameTypeList([]);
    setTimeZoneList([]);
    setSchoolLevelList([]);
    setExperienceTypeList([]);
    setGameCountList([]);
    setExperienceSubTypeList([]);
    setExperienceSubType2List([]);
    setSocialMediaList([]);
    setMessageCenterCategoryList([]);
    setAffiliationNetworkList([]);
    setPartnerOrganizationList([]);
    setExperienceLevelList([]);
    setUserList([]);
    //setAllUsersList([]);
    setEventTypeList([]);
    setEventSubType1List([]);

    setEventSubType2List([]);
    //setAdminData([]);
    setAdminScoutData([]);
    setPoolDataList([]);
    setStateWiseProfiles([]);
    setExperienceLevels([]);
    setScoutObservations({});
    setUserActivities({});
    setHireActivites([]);
    setIsLoadingDashboardData(false);
    setTotalHireInfo([]);
    setRpsmCount(0);
    setNBACandidateCampsList([]);
    setPrimaryScoutList([]);
    setInitiativeList([]);
    setAboutSourceList([]);
    setMostActiveProspectCount([]);
    setLeaseActiveProspectCount([]);
    setScoutEventCount([]);
    setEventCount([]);
    setCategory([]);
    setsubCategory([]);
    setevaluationEvents([]);
    setCompitancy([]);
    setRefereeList([]);
    setSnackMessages([]);
    setNavigationMenu([]);
    setJwtTokenDetails(null);
    setProspectDetails(null);
    setPoolProspect([]);
    setSeasonDates(null);
    setSavedFromDate(null);
    setSavedToDate(null);
    setSavedSeasonYear('');
    setSavedEventFromDate(null);
    setSavedEventToDate(null);
    setSavedEventSeasonYear('');
    setPromptData({
      isRouteBlocked: false,
      message: ""
    });
    setRoles([]);
    setAvailableRoles([]);
    setAvailableRoleData([]);
    setNotificationCountChanged(true);

  }

  const providerValue = {
    user,
    stateList,
    countryList,
    gameTypeList,
    timeZoneList,
    schoolLevelList,
    experienceTypeList,
    gameCountList,
    experienceSubTypeList,
    experienceSubType2List,
    socialMediaList,
    updateSocialMediaList: (newValue) => setSocialMediaList(newValue),
    messageCenterCategoryList,
    affiliationNetworkList,
    partnerOrganizationList,
    experienceLevelList,
    eventTypeList,
    eventSubType1List,
    eventSubType2List,
    poolDataList,
    nbaCandidateCampsList,
    primaryScoutList,
    initiativeList,
    aboutSourceList,
    //graphQLClient,
    setUser,
    userList,
    //allUsersList,
    //adminDataList,
    adminScoutDataList,
    updateMessageCategoryList,
    //updateAllUsersList,
    scoutObservations,
    stateWiseProfiles,
    experienceLevels,
    userActivities,
    hireActivities,
    updateDashboardStateList,
    updateDashboardExperienceList,
    mostActiveProspectCount,
    leastActiveProspectCount,
    scoutEventCount,
    eventCount,
    category,
    subCategory,
    evaluationEvents,
    competency,
    getUpdatedEvaluationEvents,
    refereeList,
    getDashBoardData,
    getCategoryData,
    getCompetencyData,
    snackMessages,
    navigationMenu,
    updateNavigationMenu: (newValue) => setNavigationMenu(newValue),
    jwtTokenDetails,
    addSnackMessages: (alerts, reset) => {
      if (reset) { setSnackMessages(alerts); }
      else {
        setSnackMessages([...snackMessages, ...alerts]);
      }
    },
    removeSnackMessages: (index) => { let tempAlerts = Array.from(snackMessages); tempAlerts.splice(index, 1); setSnackMessages(tempAlerts); },
    checkRole: (role) => checkRole(role),
    //refreshPoolData,
    promptData,
    setPromptData: (newValue) => setPromptData(newValue),
    fetchDefaultData: fetchDefaultData,
    updateEvaluationCateAndSubCate: updateEvaluationCateAndSubCate,
    //updateEvaluationSubCategory: updateEvaluationSubCategory,
    updateEvalCompitancy: updateEvalCompitancy,
    roles,
    availableRoles,
    setMasterRoles,
    updateNotificationCount,
    notificationCountChanged,
    //hubConnection,
    //hubConnected,
    //updateHubConnectedStatus 
    prospectDetails,
    poolProspect,
    seasonDates,
    savedFromDate,
    savedToDate,
    savedSeasonYear,
    updatedDashboardToDateState,
    updatedDashboardFromDateState,
    updatedDashboardSeasonYearState,
    refreshDashboardDatesState,
    updateDashboardDatesState,
    seasonTypeList,
    isLoadingEvents,
    sitekey,
    faqs,
    tangibles,
    getTangibleData,
    savedEventFromDate,
    savedEventToDate,
    savedEventSeasonYear,
    updatedEventDashboardToDateState,
    updatedEventDashboardFromDateState,
    updatedEventDashboardSeasonYearState,
    refreshEventDashboardDatesState,
    updateEventDashboardDatesState,
    eventCategoryList,
    eventSubCategoryList,
    clinicEvents,
    availableRoleData,
    allPermissions,
    permissionVerbList,
    leagues,
    rpsmCount,
    totalHireInfo,
    isLoadingDashboardData,
    //curriculum data
    curriculumResourceTypes,
    getAllResourceTypes,
    curriculumBadges,
    getAllBadges,
    getAllCurriculumLevels,
    curriculumLevels,
    getAllMasterCurriculums,
    curriculums,
    curriculumQuestionTypes,
    getAllQuestionTypes,
    curriculumMediaTypes,
    curriculumQuestionLevels,
    updateCurriculumBadge,
    sectionTypes,
    getCategoryList,
    quizTypes,
    allTags,
    getSiteKey,
    resetAppContext: resetAppContext,
    getFaqsData,
    getUsersList,
    getCountryList,
    getStateList,
    getPoolList,
    getAdminScoutsList,
    getRefereeList,
    getPermissions,
    getVerbsList,
    getEvents,
    getAllCurriculumQuestionLevels,
    getAllSectionTypes,
    getAllQuizTypes,
    getRoles,
    getMessageCenterCategoryList,
    getExperienceTypeMaster,
    getExperienceLevelMaster,
    getGameCountMaster,
    getTimeZoneMaster,
    getSchoolLevelMaster,
    getAllTags,
    updateAllTags
  };

  return (
    <AppDataContext.Provider value={providerValue}>
      {props.children}
    </AppDataContext.Provider>
  );
};

export const AppDataConsumer = AppDataContext.Consumer;

export default AppDataContext;
